// 汎用的なクッキー操作ユーティリティ

/**
 * クッキーに値を設定する
 * @param name クッキー名
 * @param value 値
 * @param maxAgeSeconds 有効期限（秒）
 * @param options 追加オプション
 */
export const setCookie = (
    name: string,
    value: string,
    maxAgeSeconds: number = 60 * 60 * 24 * 30, // デフォルト30日
    options: {
        path?: string;
        domain?: string;
        secure?: boolean;
        sameSite?: 'Strict' | 'Lax' | 'None';
    } = {},
): void => {
    if (!name || !value) return;

    const { path = '/', domain, secure = true, sameSite = 'Lax' } = options;

    const encodedValue = encodeURIComponent(value);
    let cookieString = `${name}=${encodedValue}; Max-Age=${maxAgeSeconds}; Path=${path}; SameSite=${sameSite}`;

    if (domain) {
        cookieString += `; Domain=${domain}`;
    }

    if (secure) {
        cookieString += '; Secure';
    }

    document.cookie = cookieString;
};

/**
 * クッキーから値を取得する
 * @param name クッキー名
 * @returns クッキーの値、存在しない場合はnull
 */
export const getCookie = (name: string): string | null => {
    if (!name) return null;

    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]+)`));
    return match ? decodeURIComponent(match[1]) : null;
};

/**
 * クッキーを削除する
 * @param name クッキー名
 * @param options 追加オプション
 */
export const clearCookie = (
    name: string,
    options: {
        path?: string;
        domain?: string;
    } = {},
): void => {
    if (!name) return;

    const { path = '/', domain } = options;
    let cookieString = `${name}=; Max-Age=0; Path=${path}`;

    if (domain) {
        cookieString += `; Domain=${domain}`;
    }

    document.cookie = cookieString;
};

/**
 * 現在のURLからクエリパラメータを取得してクッキーに保存する
 * @param paramName URLパラメータ名
 * @param cookieName クッキー名
 * @param maxAgeSeconds 有効期限（秒）
 * @param options 追加オプション
 */
export const saveParamToCookie = (
    paramName: string,
    cookieName: string,
    maxAgeSeconds: number = 60 * 60 * 24 * 30,
    options: {
        path?: string;
        domain?: string;
        secure?: boolean;
        sameSite?: 'Strict' | 'Lax' | 'None';
    } = {},
): void => {
    try {
        const params = new URLSearchParams(window.location.search);
        const value = params.get(paramName);
        if (value) {
            setCookie(cookieName, value, maxAgeSeconds, options);
        }
    } catch (_) {
        // 何もしない
    }
};
